<template>
    <div class="voicemail-preview">
        <div v-if="!hideMeta" class="voicemail-meta">
            <div v-if="row.callerName" class="voicemail-meta-item">
                <span class="voicemail-meta-label">Caller</span>
                <span class="voicemail-meta-value">{{ row.callerName }}</span>
            </div>
            <div v-if="row.from || row.phoneNumber" class="voicemail-meta-item">
                <span class="voicemail-meta-label">Phone</span>
                <span class="voicemail-meta-value">{{ formatPhone(row.phoneNumber || row.from) }}</span>
            </div>
            <div v-if="row.to" class="voicemail-meta-item">
                <span class="voicemail-meta-label">To</span>
                <span class="voicemail-meta-value">{{ row.to }}</span>
            </div>
        </div>

        <div v-if="loading" class="voicemail-loading">
            <v-progress-circular indeterminate color="success" size="24"></v-progress-circular>
            <span>Loading recording...</span>
        </div>
        <audio
            v-else-if="audioUrl"
            controls
            class="voicemail-audio"
            :src="audioUrl"
        ></audio>
        <div v-else class="voicemail-missing">No recording</div>

        <recording-transcript
            v-if="!hideTranscript"
            :recording="audioUrl || 'pending'"
            :transcription="row.transcription"
            :transcription-summary="row.transcriptionSummary"
        ></recording-transcript>

        <div v-if="!hideAssign && !row.accountID && openAssignVoicemail" class="mt-2">
            <v-btn small color="success" dark @click="openAssignVoicemail(row)">
                Assign Account
            </v-btn>
        </div>
    </div>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    name: "VoicemailPreview",
    inject: {
        openAssignVoicemail: { default: null },
    },
    props: {
        row: {
            type: Object,
            default: () => ({}),
        },
        hideAssign: {
            type: Boolean,
            default: false,
        },
        hideMeta: {
            type: Boolean,
            default: false,
        },
        hideTranscript: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            file: {},
        };
    },
    computed: {
        audioUrl() {
            return (this.file && this.file.fileURL) || this.row.recording || "";
        },
    },
    async created() {
        if (this.row.recording) {
            return;
        }
        await this.loadFile();
    },
    methods: {
        formatPhone(value) {
            if (!value) return "—";
            var digits = (value + "").replace(/\D/g, "");
            if (digits.length === 11 && digits.charAt(0) === "1") {
                digits = digits.substring(1);
            }
            if (digits.length === 10) {
                return formatPhoneNumber(digits);
            }
            return value;
        },
        async loadFile() {
            if (!this.row || !this.row.id) {
                return;
            }

            this.loading = true;
            try {
                const file = await this.$http.get(
                    "api/voicemails/getFile?voicemailID=" + this.row.id,
                );
                this.file = file || {};
            } catch (e) {
                this.file = {};
            }
            this.loading = false;
        },
    },
};
</script>
<style>
.voicemail-preview {
    padding: 4px 0;
}

.voicemail-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 18px;
    margin-bottom: 10px;
}

.voicemail-meta-item {
    display: flex;
    flex-direction: column;
}

.voicemail-meta-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #78909c;
}

.voicemail-meta-value {
    font-size: 14px;
    color: #263238;
}

.voicemail-audio {
    width: 100%;
    max-width: 480px;
    margin-bottom: 8px;
}

.voicemail-loading,
.voicemail-missing {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #90a4ae;
    margin-bottom: 8px;
}
</style>
